import { render, staticRenderFns } from "./list.registred.vue?vue&type=template&id=dc7f68ae&"
import script from "./list.registred.vue?vue&type=script&lang=js&"
export * from "./list.registred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports